import axios from 'axios';
import { handleRequest } from '../util/requestUtils';
import { ACTION_CONSTANTS } from '../constants';

const ROOT_URL = process.env.API_ROUTE + 'v1/';

export function getConfig(data) {
  let background;
  if (data && data.background) {
    background = true;
  }

  const request = axios.get(`${ROOT_URL}config`);

  return dispatch => {
    return handleRequest({
      dispatch,
      request,
      actionType: ACTION_CONSTANTS.config.get,
      hideLoader: background
    });
  };
}

export async function pushStrings() {
  return axios.get(`${ROOT_URL}push_strings`);
}

export async function getLanguageCodes() {
  return axios.get(`${ROOT_URL}google_language_codes`);
}



// WEBPACK FOOTER //
// ./src/actions/api/config.js